import { Component, OnInit } from '@angular/core'
import { Location } from '@angular/common'
import { Observable } from 'rxjs'

import { PlatformSettings } from '@shared/models/platform-settings.model'
import { PlatformSettingsService } from '@core/services/platfrom-settings.service'

@Component({
  selector: 'lin-check-mobile-phone',
  templateUrl: './check-mobile-phone.component.html',
  styleUrls: ['./check-mobile-phone.component.scss'],
  standalone: false,
})
export class CheckMobilePhoneComponent implements OnInit {
  platformSettings$: Observable<PlatformSettings>

  constructor(
    private location: Location,
    private readonly platformSettingsService: PlatformSettingsService,
  ) {}

  ngOnInit(): void {
    this.platformSettings$ = this.platformSettingsService.platformSettings$
  }

  goBack() {
    this.location.back()
  }
}
